import { useMutation } from '@tanstack/react-query'
import { postWalletAction } from 'services/WalletsService'

export const useWalletActionMutation = () => useMutation({ mutationFn: postWalletAction })
